import { useEffect } from 'react';

// Observa todos los elementos [data-reveal] de la página y les añade
// .is-visible cuando entran al viewport (una sola vez).
const useReveal = () => {
  useEffect(() => {
    const elements = Array.from(document.querySelectorAll('[data-reveal]'));
    if (!elements.length) return undefined;

    const pending = new Set(elements);

    const show = (el) => {
      el.classList.add('is-visible');
      pending.delete(el);
    };

    if (!('IntersectionObserver' in window)) {
      elements.forEach(show);
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            show(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );

    elements.forEach((el) => observer.observe(el));

    // Fallback: los saltos de scroll (anclas, End) pueden cruzar el viewport
    // en un solo frame sin disparar el observer; revelamos lo que ya pasó.
    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        ticking = false;
        pending.forEach((el) => {
          if (el.getBoundingClientRect().top < window.innerHeight * 0.95) {
            observer.unobserve(el);
            show(el);
          }
        });
        if (!pending.size) window.removeEventListener('scroll', onScroll);
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });

    return () => {
      observer.disconnect();
      window.removeEventListener('scroll', onScroll);
    };
  }, []);
};

export default useReveal;
